import React, { useEffect, useState } from "react";
import { Loader2, CheckCircle2, ShieldCheck } from "lucide-react";
import { Breadcrumb, GradientPanel } from "../components/common";
import api from "../lib/api";

const BatchApproval = () => {
  const [rows, setRows] = useState([]);
  const [sel, setSel] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");

  const load = async () => { setLoading(true); try { const { data } = await api.get("/invoices"); setRows(data); } catch {} finally { setLoading(false); } };
  useEffect(() => { load(); }, []);

  const toggle = (id) => setSel((s) => s.includes(id) ? s.filter((x) => x !== id) : [...s, id]);
  const all = () => setSel(sel.length === rows.length ? [] : rows.map((r) => r.id));
  const approve = async () => {
    setBusy(true); setMsg("");
    try { const { data } = await api.post("/invoices/batch-approve", { ids: sel }); setMsg(data.narrative); setSel([]); load(); }
    catch { } finally { setBusy(false); }
  };

  return (
    <div>
      <Breadcrumb items={[{ label: "Dashboard", path: "/a/dashboard" }, { label: "Batch Approval" }]} />
      <GradientPanel>
        <div className="flex items-start justify-between flex-wrap gap-3">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Batch Approval</h1>
            <p className="text-sm text-gray-500 mt-1">Documents are auto-approved by the agent. Use this optional admin screen to review &amp; confirm submission in bulk - every action is audit-logged.</p>
          </div>
          <button onClick={approve} disabled={busy || sel.length === 0} className="inline-flex items-center gap-2 text-sm font-semibold text-white bg-indigo-600 hover:bg-indigo-700 disabled:opacity-50 px-4 py-2 rounded-lg transition">{busy ? <Loader2 size={15} className="animate-spin" /> : <ShieldCheck size={15} />} Approve &amp; submit ({sel.length})</button>
        </div>
        {msg && <div className="mt-4 text-sm inline-flex items-center gap-2 text-emerald-700 bg-emerald-50 border border-emerald-100 rounded-lg px-3 py-2"><CheckCircle2 size={15} /> {msg}</div>}
        {loading ? <div className="py-16 flex justify-center"><Loader2 className="animate-spin text-indigo-500" size={26} /></div> : (
          <div className="mt-5 overflow-x-auto">
            <table className="w-full text-sm">
              <thead><tr className="text-left text-gray-500 border-b border-gray-100">
                <th className="py-2 px-2 w-8"><input type="checkbox" checked={sel.length === rows.length && rows.length > 0} onChange={all} /></th>
                <th className="py-2 font-semibold">Number</th><th className="py-2 font-semibold">Buyer</th><th className="py-2 font-semibold">Scenario</th><th className="py-2 font-semibold text-right">Total</th><th className="py-2 font-semibold text-center">Approval</th>
              </tr></thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.id} className="border-b border-gray-50 hover:bg-gray-50">
                    <td className="py-2 px-2"><input type="checkbox" checked={sel.includes(r.id)} onChange={() => toggle(r.id)} /></td>
                    <td className="py-2 font-medium text-gray-800">{r.number}</td>
                    <td className="py-2 text-gray-600">{r.buyer?.name}</td>
                    <td className="py-2 text-gray-500">{r.scenario_label}</td>
                    <td className="py-2 text-right text-gray-800">{r.totals.total.toFixed(2)} {r.currency}</td>
                    <td className="py-2 text-center"><span className="text-[11px] font-semibold text-emerald-600 bg-emerald-50 px-2 py-0.5 rounded">{r.approved ? "Auto-approved" : "Pending"}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </GradientPanel>
    </div>
  );
};

export default BatchApproval;
